module.exports = __webpack_public_path__ + "static/media/1230_Music_Rock_HL.aebff1cf.png";